<template>
  <main class="p-4 pt-14 lg:pt-24 min-h-screen" v-if="page">
    <div v-if="!success">
      <k-layout :content="page.layout" />
      <div class="mb-4">
        <input type="email" name="email" v-model="email" placeholder="Email" />
        <input
          type="date"
          name="orderdate"
          v-model="orderdate"
          placeholder="Order Date"
        />
      </div>
      <button @click="sendInquiry" class="btn action">Submit</button>
    </div>
    <div v-else>Thank you. We will get in touch as soon as possible</div>
    <div v-if="error">Please fill order correctly</div>
  </main>
</template>

<script>
import axios from "axios";
const KLayout = () =>
  import(/* webpackChunkName: "KLayout" */ "@/components/Layout.vue");
export default {
  name: "about",
  metaInfo() {
    return {
      title: "– " + this.page.title,
    };
  },
  data() {
    return {
      email: null,
      orderdate: null,
      success: false,
      error: false,
    };
  },
  components: {
    KLayout,
  },
  computed: {
    page() {
      return this.$store.state.pages[this.$route.name];
    },
  },
  methods: {
    sendInquiry() {
      if (this.email && this.orderdate) {
        axios
          .post(
            "/api/inquire",
            {
              orderdate: this.orderdate,
              email: this.email,
            },
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
              },
              auth: {
                username: process.env.VUE_APP_USERNAME,
                password: process.env.VUE_APP_PASSWORD,
              },
            }
          )
          .then(() => {
            this.error = false;
            this.success = true;
            // console.log("Succes: ", res);
          })
          .catch(() => {
            this.error = true;
            // console.log("Fail", err);
          });
      } else {
        this.error = true;
      }
    },
  },
};
</script>
